import { getMyGroupListApi } from '@/api/common/invite'

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useInviteStore = defineStore('invite', () => {
  const inviteGroupOptions = ref<{ label: string; value: string }[]>([])
  const getInviteGroupOptions = async (accountType?: string) => {
    try {
      const res = await getMyGroupListApi({ account_type: accountType })
      inviteGroupOptions.value = res.map((item) => ({
        label: item.tag,
        value: item.invent_code,
      }))
    } catch (error: any) {
      throw new Error(error)
    }
  }

  return {
    inviteGroupOptions,
    getInviteGroupOptions,
  }
})
